import React, { useEffect } from "react";
import T from "../../Helpers/Translations";
import APIModel from "../../Models/APIModel";

export default function ActivateCardModal({
  open,
  onClose,
  lang = "EN",
  onActivate,
}) {
  useEffect(() => {
    if (open) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [open]);

  if (!open) return null;

  // const isRTL = document.documentElement.getAttribute("dir") === "rtl";
  const t = T[0];

  return (
    <>
      {/* Backdrop removed (as requested) */}

      {/* Modal */}
      <div
        className={`modal fade show d-block`}
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        style={{ background: "rgba(0,0,0,0.4)" }}
      >
        <div
          className="modal-dialog modal-dialog-centered box-shadow-none"
          role="document"
          style={{ maxWidth: "720px", boxShadow: "none" }}
        >
          <div
            className="modal-content p-0"
            style={{
              borderRadius: 16,
              overflow: "hidden",
              border: "none",
            }}
          >
            {/* Modal Body */}
            <div
              className="p-4"
              style={{
                background: "linear-gradient(160deg, #f7f9fc 0%, #eef3f9 100%)",
              }}
            >
              <div
                className="bg-white p-4 w-100"
                style={{
                  borderRadius: 16,
                  boxShadow: "0 12px 32px rgba(0,0,0,.18)",
                  border: "1px solid #e9eef5",
                }}
              >
                {/* Logo */}
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <img src="assets/images/easy-card.png" alt="logo" />
                  <button
                    onClick={onClose}
                    type="button"
                    className="close"
                    aria-label="Close"
                    style={{
                      fontSize: "1.2rem",
                      border: "none",
                      cursor: "pointer",
                      padding: 0,
                      margin: 0,
                    }}
                  >
                    <span aria-hidden="true">❌</span>
                  </button>
                </div>

                {/* Badge */}
                <span
                  className="d-inline-block mb-2 font-weight-bold"
                  style={{
                    padding: "4px 10px",
                    borderRadius: 50,
                    background: "rgba(30,136,229,.10)",
                    color: "#1E88E5",
                    fontSize: ".85rem",
                  }}
                >
                  {t.Activation[lang]}
                </span>

                {/* Title */}
                <h3 className="font-weight-bold mb-2">{t.ModalTitle[lang]}</h3>

                {/* Description */}
                <p className="text-muted">{t.ModalDescription[lang]}</p>

                {/* ACTION BUTTONS */}
                <div className="d-flex flex-wrap">
                  <a
                    href={`tel:${APIModel.CONTACT_US}`}
                    className="btn btn-primary mb-2 mr-2"
                    style={{
                      background: "linear-gradient(135deg, #1E88E5, #00BCD4)",
                      border: "none",
                      padding: "14px 18px",
                      borderRadius: 12,
                      fontWeight: 600,
                      boxShadow: "0 8px 20px rgba(30,136,229,.35)",
                    }}
                  >
                    {t.CallNow[lang]}
                  </a>

                  <button
                    onClick={onActivate}
                    className="btn btn-outline-primary mb-2 mr-2"
                    style={{
                      padding: "14px 18px",
                      borderRadius: 12,
                      fontWeight: 600,
                      borderColor: "rgba(30,136,229,.25)",
                      color: "#1E88E5",
                    }}
                  >
                    {t.HaveCode[lang]}
                  </button>

                  {/* <button
                    className="btn btn-light mb-2"
                    style={{
                      padding: "14px 18px",
                      borderRadius: 12,
                      fontWeight: 600,
                      color: "#6B7280",
                    }}
                    onClick={onClose}
                  >
                    {t.CloseWindow[lang]}
                  </button> */}
                </div>

                {/* Footer */}
                <div
                  className="border-top pt-3 mt-3 text-muted"
                  style={{ fontSize: ".9rem" }}
                >
                  {t.FooterText[lang]}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
